/* global translations */
import React from 'react';
import get from 'lodash/get';
import { ImageSvg } from '../image';
import SuggestionsExtendedStore from '../../stores/SuggestionsExtendedStore';

const ExtendedFormSubmitSuccess = () => {
  const questions = SuggestionsExtendedStore.getQuestions();
  const formData = SuggestionsExtendedStore.getFormData();

  const email = SuggestionsExtendedStore.getEmail();

  const files = SuggestionsExtendedStore.getAttachments();
  const filenames = Object.keys(files);

  const answer = (question) => {
    const formDataAnswer = get(formData, question.id, '');
    if (!formDataAnswer) {
      return '-';
    }

    if (!Object.prototype.hasOwnProperty.call(question, 'answers')) {
      return formDataAnswer;
    }

    const chosenAnswer = question.answers.find((a) => a.value === formDataAnswer);
    return get(chosenAnswer, 'label', '-');
  };

  return (
    <div className="paxl pts tal bb">
      {Object.values(questions).map((item) => (
        <div key={item.id}>
          <div className="mtl mlxs twb">
            {item.title}
          </div>
          <div className="mbs mlxs">
            {answer(item)}
          </div>
        </div>
      ))}
      {filenames.length > 0 && (
        <div className="mbs">
          <div className="mtl mlxs twb">
            {get(translations, 'txt: Pievienotie pielikumi', 'txt: Pievienotie pielikumi')}
          </div>
          {filenames.map((filename) => (
            <div key={filename} className="mlxs tsi">
              {filename}
            </div>
          ))}
        </div>
      )}
      <div>
        <div className="mtl mlxs twb">
          {get(translations, 'txt: E-pasts, uz kuru varam Tev atbildēt', 'txt: E-pasts, uz kuru varam Tev atbildēt')}
        </div>
        <div className="mbs mlxs">
          {email}
        </div>
      </div>
      <div className="block">
        <div className="mtl mlxs twsnw">
          <div className="message por">
            <div className="flash-inner success">
              <div className="flash-icon">
                <ImageSvg svg="icon-check-2" iconClass="icon--full icon--check-2" />
              </div>
              <div className="flash-content">
                {get(translations, 'txt: Paldies, Tavs ziņojums ir nosūtīts!', '')}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mtl mlxs tsi">
        {get(translations, 'txt: Ņem vērā, ka administrācija izskata ziņojumus darba laikā: Pirmdiena - Piektdiena 9:00-17:00', '')}
      </div>
    </div>
  );
};

export default ExtendedFormSubmitSuccess;
